import { render } from "./BillSplitter.vue?vue&type=template&id=612cba44&scoped=true&ts=true"
import script from "./BillSplitter.vue?vue&type=script&lang=ts"
export * from "./BillSplitter.vue?vue&type=script&lang=ts"

import "./BillSplitter.vue?vue&type=style&index=0&id=612cba44&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612cba44"]])

export default __exports__